import styled from 'styled-components';

import { FCWithChildren } from 'common/types';
import ErrorView from 'components/ErrorView';
import Loader from 'components/Loader';

// This page layout behaves like a modal accessible via an URL
// @see https://reactrouter.com/web/example/modal-gallery
const Root = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.colors.white(0)};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
`;

interface FullPageLayoutProps {
  hasError?: boolean;
  loading: boolean;
}

const FullPageLayout: FCWithChildren<FullPageLayoutProps> = ({
  children,
  hasError,
  loading,
}) => {
  const getContent = () => {
    if (loading) {
      return <Loader />;
    }

    if (hasError) {
      return <ErrorView />;
    }

    return children;
  };

  return <Root>{getContent()}</Root>;
};

export default FullPageLayout;
